const {
	REACT_APP_DOWNLOAD_STAFF_TEMPLATE: DOWNLOAD_STAFF_TEMPLATE,
} = process.env;

export const downloadMassiveStaffTemplate = () => {
    window.open(DOWNLOAD_STAFF_TEMPLATE, "_blank")
}
